import React, {useEffect, useState} from "react";
import ToastSuccess from "../toastSuccess/ToastSuccess";
import ToastError from "../toastError/ToastError";
import ToastPermission from "../toastPermission/ToastPermission";
import { useEffectOnlyUpdate } from "../../../../utils/use_custom/useEffectCustom";

const ToastListError = ({ list = [], closeAction }) => {

	useEffect(() => {
		const timers = list.map((toast) => 
			setTimeout(() => {
				closeAction(toast); // Remove each toast after 3 seconds
			}, 5000)
		);

	});

	return (
		<>
			<div className="shared-toastListError">
				{list.map((toast) => {
					switch (toast.type) {
						case "success":
							return (
								<ToastSuccess
									key={toast.id}
									{...toast}
									closeAction={() => closeAction && closeAction(toast)}
								/>
							);
						case "error":
							return (
								<ToastError
									key={toast.id}
									{...toast}
									closeAction={() => closeAction && closeAction(toast)}
								/>
							);
						case "unauthorized":
							return (
								<ToastPermission
									key={toast.id}
									{...toast}
									closeAction={() => closeAction && closeAction(toast)}
								/>
							);
						default:
							return;
					}
				})}
			</div>
		</>
	);
};

export default ToastListError;
